
const AwardStar = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path
                d="M365.5-314 480-383.5 594.5-314 564-444l101.5-88L532-543l-52-123-52 123-133.5 11L396-444l-30.5 130ZM480-41 350-170H170v-180L41-480l129-130v-180h180l130-129 130 129h180v180l129 130-129 130v180H610L480-41Zm0-105 99-99h136v-136l99-99-99-99v-136H579l-99-99-99 99H245v136l-99 99 99 99v136h136l99 99Zm0-334Z" />
        </svg>
    )
}

export default AwardStar;